export function obfuscateText(value: string, characters: number, email?: boolean): string {
  if (!value) {
    return;
  }
  if (email) {
    const [local, domain] = value.split('@');
    if (!domain || local?.length <= characters) {
      return value;
    }
    return `${local?.slice(0, characters)}${'*'.repeat(local?.length - characters)}@${domain}`;
  }
  if (value?.length <= characters) {
    return value;
  }
  return `${value?.slice(0, characters)}${'*'.repeat(value?.length - characters)}`;
}
